import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import BaseComponent from 'src/components/BaseComponent';
import { FileBox, Logo, MCButton, Spinner } from 'src/components/basic';
import SVGIcon, { DOCTOR_ICONS } from 'src/components/svg';
import DoctorDetail from 'src/components/doctor/DoctorDetail';
import { MediaGroup, popupModel } from 'src/components/complex';

import {
  countFormat,
  getFileInfoFromUri,
  getSelectLabel,
  lang,
  openApp,
  permissions,
  remCss,
  userFullName,
  withRouter
} from 'src/helpers';

import model from './model';
import constants from 'src/constants';
import FooterInfo from 'src/components/FooterInfo';
import AuthPopup from 'src/components/authPopup';
import NoAvatar from 'src/assets/images/no-avatar.svg';
import LANG_CONST from 'src/helpers/lang/const';

class Doctor extends BaseComponent {
  state = {
    loading: true
  };
  componentDidMount() {
    this.setState({ loading: true });
    model.subscribe(this.subscription);
    let username = this.props.router.params.username;
    if (['/', '', 'admin'].indexOf(username) < 0) {
      model.loadDetail(username, (err) => {
        if (!err) {
          this.setState({ loading: false });
          model.selectedMonth(moment());
        } else {
          this.navigate('/');
        }
      });
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  openMessages = () => {
    let doctor = model.state.doctor;
    this.beforeAction('chat', (params) => {
      if (!openApp(params)) {
        setTimeout(() => {
          model.emit('openDoctorMessages', doctor);
          this.navigate(permissions.PAGES.MESSAGES_USER_PAGE.match(doctor.username));
        }, 200);
      }
    });
  };

  beforeAction = (action, cb) => {
    let doctor = model.state.doctor;
    if (model.isLogged) {
      cb({ action, contactId: doctor.id });
    } else {
      popupModel.setActivePopup('auth_popup', {
        active: true,
        component: AuthPopup,
        // noHideOutSide: true,
        props: {
          role: 'patient',
          afterAuth: () => {
            cb({ action, contactId: doctor.id });
            popupModel.setActivePopup('auth_popup', { active: false });
          }
        }
      });
    }
  };

  onBook = (slot) => {
    let doctor = model.state.doctor;
    this.beforeAction('book', (params) => {
      if (!openApp(params)) {
        setTimeout(() => {
          this.navigate(permissions.PAGES.APPOINTMENTS_BOOK_PAGE.match(doctor.username), {
            state: { slot }
          });
        }, 200);
      }
    });
  };

  renderImage = () => {
    const { doctor } = model.state;

    let { images = [], avatar } = doctor;

    if (avatar && !images.find((img) => img === doctor.avatar)) {
      images.unshift(doctor.avatar);
    }

    if (images.length === 0) images.unshift(NoAvatar);

    const mainWidth = (this.props.screenDetail?.innerWidth - remCss(70)) / 2;
    const media = images.map(getFileInfoFromUri);

    return !this.props.screenDetail.isLargeScreen ? (
      <div className={'mc-doctor-profile-left'}>
        <div
          className={`mc-flex-10 mc-p10 mc-bg-primary-light mc-flex-start ${this.props.screenDetail?.isLargeScreen ? '' : 'mc-doctor-background'}`}
        >
          <div className={'mc-grow'}>
            <FileBox
              template={3}
              list={media}
              file={media[0]}
              onClose={null}
              styles={{
                width: mainWidth,
                height: mainWidth,
                objectFit: 'container'
              }}
              onlyPreview={true}
              showFileName={false}
            />
          </div>
          <div className={'mc-grow'}>
            <MCButton
              onClick={(e) => {
                e.preventDefault();
                this.onBook();
              }}
              label={'Appointments'}
              large
              dark
              radius
            />
          </div>
        </div>
      </div>
    ) : (
      !!images?.length && (
        <div className={'mc-doctor-profile-left'}>
          <div style={{ maxWidth: remCss(550) }}>
            <MediaGroup images={images} template={4} mainStyle={{}} />
          </div>
        </div>
      )
    );
  };

  render() {
    const { doctor } = model.state;
    if (this.state.loading || !doctor)
      return (
        <div className={'mc-m-auto'}>
          <Spinner />
        </div>
      );
    let experience = doctor.yearOfStarting
      ? moment().year() - doctor.yearOfStarting + 1
      : doctor.training;
    if (experience > 0) {
      experience = lang.t(experience > 1 ? LANG_CONST.amount_years : LANG_CONST.amount_year, {
        amount: experience
      });
    }
    return (
      <div className={'mc-container mc-doctor-profile'}>
        <div
          className={`mc-container-main ${!this.props.screenDetail?.isLargeScreen ? '' : 'mc-doctor-background'}`}
        >
          <div className={'mc-flex mc-wrap mc-flex-start'}>
            <Link className={'mc-pointer mc-p10'} style={{ flex: 0 }} to={'/'}>
              <Logo logoProps={{ width: 60, height: 60 }} />
            </Link>
            {/*<div className={'mc-icon'}>*/}
            {/*  <SVGIcon iconname={DOCTOR_ICONS.DROPLET} />*/}
            {/*</div>*/}
          </div>
          <div
            className={'mc-container-content__body-gap horizontal mc-wrap'}
            style={{ gap: '14%' }}
          >
            {this.renderImage()}
            <div className={'mc-container-content__body-gap-center'}>
              <div className={'mc-flex-60-col'}>
                <div className={'mc-flex-10-col'}>
                  <div className={'mc-flex-10'}>
                    <span className={'mc-value-660'}>{userFullName(doctor, true)}</span>
                    <SVGIcon iconname={DOCTOR_ICONS.DOCTOR_CHECK} />
                  </div>
                </div>
                <pre className={'mc-text-420'} style={{ lineHeight: remCss(34) + 'px' }}>
                  {doctor.description}
                </pre>
                {doctor.specialist?.length > 0 && (
                  <div className={'mc-flex-15 mc-wrap'}>
                    {getSelectLabel(constants.general.specialist, doctor.specialist)
                      .split(', ')
                      .map((txt, i) => (
                        <div key={i} className={'mc-specialist'}>
                          {txt}
                        </div>
                      ))}
                  </div>
                )}
                <MCButton
                  onClick={this.openMessages}
                  label={LANG_CONST.buttons.ask_question}
                  large
                  dark
                  radius
                  style={{ width: remCss(300) }}
                />
                <div className={'mc-flex-20'}>
                  <div className={'mc-flex-10-col mc-grow'}>
                    <div className={'mc-text-420'}>{lang.t(LANG_CONST.total_treatments)}</div>
                    <div className={'mc-value-624'}>{countFormat(doctor.treatmentCount)}</div>
                  </div>
                  <div className={'mc-flex-10-col mc-grow'}>
                    <div className={'mc-text-420'}>{lang.t(LANG_CONST.total_patients)}</div>
                    <div className={'mc-value-624'}>
                      {countFormat((doctor.patientIds || []).length)}
                    </div>
                  </div>
                  <div className={'mc-flex-10-col mc-grow'}>
                    <div className={'mc-text-420'}>{lang.t(LANG_CONST.total_experience)}</div>
                    <div className={'mc-value-624'}>{experience}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'mc-container-content'}>
          <DoctorDetail doctor={doctor} model={model} onOpenDoctor={this.onBook} />
        </div>

        <FooterInfo isRotate={this.props.screenDetail.isSmallScreen} />
      </div>
    );
  }
}

export default withRouter(Doctor);
